import { render, staticRenderFns } from "./CalendarioCobrosComponent.vue?vue&type=template&id=2785074e"
import script from "./CalendarioCobrosComponent.vue?vue&type=script&lang=js"
export * from "./CalendarioCobrosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports